/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Sort_SignalInputs */



/**
* | output |
* | --- |
* | "Signal" |
*
* @param {Mesh_Sort_SignalInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_sort_signal = /** @type {((inputs?: Mesh_Sort_SignalInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Sort_SignalInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Signal")
	return /** @type {LocalizedString} */ ("Signal")
});